import Swiper from "swiper";
import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const beaf = document.querySelector(".beaf");
  const beafItems = beaf?.querySelectorAll(".beaf-item");

  if (beaf && beafItems.length) {
    beafItems.forEach((item, idx) => {
      const width = item.clientWidth;

      const line = item.querySelector(".beaf-item__line");
      if (!line) return;

      item.setAttribute("style", `--width: ${(width / 100) * 50}px; --left-line: ${(width / 100) * 50 - line.clientWidth / 2}px`);

      let mouseDown = false;

      const newPosition = (e, mouse = null) => {
        line.removeAttribute("style");
        let left;
        if (e.touches) {
          gsap.to(document.body, { overflow: "hidden", delay: 0, duration: 0 });
          document.documentElement.classList.add('hidden')
          left = e.touches[0].clientX - item.offsetLeft;
        } else {
          left = e.x - item.offsetLeft;
        }

        if (left <= 0) left = 0;
        if (left >= width) left = width;

        if (mouse) {
          gsap.to(item, {
            "--width": `${left}px`,
            "--left-line": `${left - line.clientWidth / 2}px`,
            duration: 0.3,
            delay: 0,
          });
          return;
        }

        item.setAttribute("style", `--width: ${left}px; --left-line: ${left - line.clientWidth / 2}px`);
      };

      item.addEventListener("mousedown", (e) => {
        mouseDown = true;
        if (e.target !== line && !line.contains(e.target)) newPosition(e, true);
      });

      item.addEventListener("touchstart", (e) => {
        mouseDown = true;
        if (e.target !== line && !line.contains(e.target)) newPosition(e, true);
      });

      document.addEventListener("mouseup", () => (mouseDown = false));
      document.addEventListener("touchend", () => {
        mouseDown = false;
        gsap.to(document.body, { overflow: "hidden auto", delay: 0, duration: 0 });
        document.documentElement.classList.remove('hidden')
      });

      item.addEventListener("mousemove", (e) => {
        if (mouseDown) newPosition(e);
      });

      item.addEventListener("touchmove", (e) => {
        if (mouseDown) newPosition(e);
      });
    });

    // Color picker
    const colorPickerSwiperEl = document.querySelector(".color-picker__slider");
    const colorPickerSwiperWrapper = document.querySelector(".color-picker__items");
    const colorItems = beaf.querySelectorAll(".color-picker__item");
    const beafList = beaf.querySelector(".beaf__list");
    const tuningMaterials = document.querySelector(".tuning .tuning-buttons__material .tuning-buttons__input");
    let activeColor = null;
    let timeLine = gsap.timeline();

    // Color picker hint
    const colorPickerHint = document.querySelector(".color-picker__hint");
    colorItems.forEach((color) => {
      color.addEventListener("mouseover", () => {
        colorPickerHint.classList.add("shown");
      });
      color.addEventListener("mouseleave", () => {
        colorPickerHint.classList.remove("shown");
      });
      color.addEventListener("mousemove", () => {
        const colorRect = color.getBoundingClientRect();
        colorPickerHint.textContent = color.dataset.title;
        colorPickerHint.style.top = colorRect.top + "px";
        colorPickerHint.style.left = colorRect.left + colorRect.width / 2 + "px";
      });
    });

    document.addEventListener('touchmove', () => {
      colorPickerHint.classList.remove('shown')
    })


    if (colorItems) {
      const showItemsByColor = (color) => {
        const allItems = beaf.querySelectorAll(".beaf-item");
        let itemsToShow = [];
        beafItems.forEach((item) => {
          const itemColor = item.dataset.color;
          const itemMaterial = item.dataset.material;
          if (color == itemColor && ((!tuningMaterials?.checked && itemMaterial == "carbon") || (tuningMaterials?.checked && itemMaterial == "gloss"))) {
            itemsToShow.push(item);
            item.classList.add("shown");
          } else {
            item.classList.remove("shown");
          }
        });
        beafList.style.height = window.getComputedStyle(beafList).height;
        timeLine.to(allItems, { duration: 0.3, autoAlpha: 0, display: "none" });
        timeLine.to(itemsToShow, {
          duration: 0.3,
          autoAlpha: 1,
          display: "block",
          onComplete: () => {
            beafList.style.height = "unset";
          },
        });
      };

      const activateColorItem = (item) => {
        colorItems.forEach((colorItem) => {
          colorItem.classList.remove("active");
        });
        item?.classList.add("active");
      };

      const firstColorItem = colorItems[0];

      activateColorItem(firstColorItem);

      showItemsByColor(firstColorItem.dataset.color);

      colorItems.forEach((colorItem) => {
        const itemColor = colorItem.dataset.color;

        if (itemColor) {
          colorItem.addEventListener("click", () => {
            if (activeColor != itemColor) {
              activeColor = itemColor;
              showItemsByColor(itemColor);
              activateColorItem(colorItem);
            }
          });
        }
      });
    }
  }
});
